import React, {useEffect, useRef, useState} from 'react';
import MainLayout from "../../layouts/main";
import HelperService from "../../services/helper-service";
import Section from "../../components/section";
import {useInboxService} from "../../services/inbox-service";
import {useGlobalNotificationMessage} from "../../context/message";
import {Link} from "react-router-dom";
import {AppRoutes} from "../../utils/constants";
import InitialLoading from "../../components/initial-loading";
import {Modal} from "react-bootstrap";
import {useTrainerService} from "../../services/trainer-service";
import Loading from "../../components/loading";
import ClassReview from "../../components/class-review";
import StripeEventTipModal from "../../components/stripe-event-tip-modal";
import {useEventService} from "../../services/event-service";
import {useAuth} from "../../context/auth";
import LightGallery from "lightgallery/react";
import lgThumbnail from "lightgallery/plugins/thumbnail";
import lgZoom from "lightgallery/plugins/zoom";

export default function Inbox () {
  const [loaded, setLoaded] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [detailLoaded, setDetailLoaded] = useState(true);
  const [messages, setMessages] = useState([]);
  const [showMessageDetail, _setShowMessageDetail] = useState(false);
  const [showClearInboxModal, setShowClearInboxModal] = useState(false);
  const eventTipModal = useRef();
  const [showLoadMore, setShowLoadMore] = useState(false);

  const {addErrorMessage} = useGlobalNotificationMessage();
  const inboxService = useInboxService();
  const trainerService = useTrainerService();
  const eventService = useEventService();

  const dayjs = HelperService.getDayjs();
  const auth = useAuth();

  useEffect(() => {
      let promises = [
          inboxService.getList(),
          inboxService.reset()
      ];
      Promise.all(promises).then(async ([_messages, reset =null]) => {
        setMessages(_messages?.inbox.map((im)=>mapInboxItem(im)) || []);

        if (_messages.inbox?.length>=20){
          setShowLoadMore(true);
        } else setShowLoadMore(false);

        auth.setUnreadMessagesCount(0);
        setLoaded(true);
      }).catch(error => {
        HelperService.handleApiErrors(error, addErrorMessage);
      });
  // eslint-disable-next-line
  }, []);

  function mapInboxItem(im){
    im.exact = im.content.replace(/<p>/g, '').replace(/<\/p>/g, '<br>');
    im.date = dayjs(im.timestamp, 'x');

    //set defaults
    im.trainerCover = im.cover;
    im.cover = im.thumbnail ? im.thumbnail : null;
    im.link = im.eventID ? `${AppRoutes.events.path}/${im.eventID}` : null;
    im.showDetail = true;

    //set overrides based on type
    switch (im.type){
      case "USER_REGISTERED":
        im.trainerCover = 'https://s3.amazonaws.com/sweatnow-prod/users/148_1546994620.jpg';
        im.cover = '/assets/images/covers/Generic_12.jpg';
        im.trainer = {id: 148, name:'Andrea', surname: 'Sarbacker'};
        break;
      case "CLASS_CANCELLED":
      case "CLASS_CANCELLED_TRAINER":
        im.link = null;
        im.showDetail = false;
        break;
      case "CLASS_END_RECURRING":
        im.link = `${AppRoutes.schedule.path}`;
        break;
      default: break;
    }
    return im;
  }

  function loadMoreMessages(){
    setSubmitting(true);
    inboxService.getList({from: messages[messages.length-1].timestamp})
        .then((_messages) => {
          //we make unique check before adding the next set
          let idSet = new Set(messages.map(event => event.id));
          _messages = _messages?.inbox?.filter(event => !idSet.has(event.id));
          _messages = _messages?.map((im)=>mapInboxItem(im));

          setMessages([...messages, ..._messages]);
          //setMessages([...messages, ..._messages.reverse()]);
          if (_messages?.length>=20){
            setShowLoadMore(true);
          } else setShowLoadMore(false);
          setLoaded(true);
          setSubmitting(false);
        }).catch(error => {
      setSubmitting(false);
      HelperService.handleApiErrors(error, addErrorMessage);
    });
  }

  const cleanInbox = () => {
    setSubmitting(true);
    inboxService.clean().then(async () => {
      setMessages([]);
      setSubmitting(false);
    }).catch(error => {
      HelperService.handleApiErrors(error, addErrorMessage);
      setSubmitting(false);
    });
  };

  const setShowMessageDetail = (message) => {
    if (!message){
      _setShowMessageDetail(message);
      return;
    }

    let promises = [];
    if (message?.trainerID){
      promises.push(message?.trainerID ? trainerService.getDetail(message?.trainerID) : Promise.resolve(null));
    }

    if (message?.eventID){
      promises.push(message?.eventID ? eventService.getDetail(message?.eventID) : Promise.resolve(null));
    }

    //prepare message for detail view
    Promise.all(promises).then(async ([trainer=null, event=null]) => {
      message.trainerDetail = message.trainer || trainer || null;
      message.eventDetail = event?.events.length>0 ? event?.events[0] : null;
      _setShowMessageDetail(message);
      setDetailLoaded(true);
    }).catch(error => {
      HelperService.handleApiErrors(error, addErrorMessage);
    });
  };


  const InboxMessageCell = function ({message, ...props}) {

    const IMC = function(){
      return (<div className={`card border-0 rounded-3 mb-2 ${message.showDetail ? 'clickable': ''}`} onClick={message.showDetail ? ()=>setShowMessageDetail(message) : undefined}>
        <div className="card-body position-relative">
          <div className="d-flex gap-3">
            <div className="flex-shrink-0" style={{width: '80px'}}>
              <div className="rounded-circle bg-cover flex-shrink-0 bg-light-subtle" style={{backgroundImage: `url(${message?.trainerCover})`, width: '80px', height: '80px'}}></div>
            </div>
            <div className="flex-grow-1">
              <h6>{message.title}</h6>
              <div dangerouslySetInnerHTML={{__html: message?.exact}} className="overflow-hidden text-fadeout" style={{maxHeight:'88px'}}></div>
              <div className="mt-1 text-secondary"><span className="mdi mdi-clock-outline"></span> {message?.date?.format('dddd, D MMM, HH:mm')} </div>
            </div>
          </div>
          {message?.link && <Link to={`${message?.link}`} className="router-link text-dark stretched-link"></Link>}
        </div>
        {/*{process.env.REACT_APP_DEBUG==='true' && message?.eventID &&*/}
        {/*    <button type="button" className="btn btn-outline-primary z-3 m-2"*/}
        {/*            onClick={(e)=>{*/}
        {/*              e.preventDefault();*/}
        {/*              eventTipModal.current.openModal({eventId: message.eventID, event: message.eventDetail});*/}
        {/*              setShowMessageDetail(null);*/}
        {/*              return false;*/}
        {/*            }}>tip</button>*/}
        {/*}*/}
      </div>)
    };
    return (<>
      <IMC />
    </>);
  }

  const MessageDetailModal = function() {
    const closeModal = () => setShowMessageDetail(null);

    return <Modal size='xl' show={showMessageDetail?.id} onHide={closeModal} centered>
      <Modal.Header closeButton>
        {detailLoaded && <>
          <div className="rounded-circle bg-cover flex-shrink-0 bg-light-subtle" style={{backgroundImage: `url(${showMessageDetail?.trainerCover})`, width: '80px', height: '80px'}}></div>
          {showMessageDetail?.trainerDetail && <h4 className="header-stripe-blue col-sm-6 pb-1 ms-3">{showMessageDetail?.trainerDetail?.name} {showMessageDetail?.trainerDetail?.surname}</h4>}
        </>}
      </Modal.Header>
      <Modal.Body className="p-sm-3 p-md-5">
        <Section animation={HelperService.getRandomAnimation()}>
          <div className="row">
            {!detailLoaded && <div><Loading/></div>}
            {detailLoaded && <>
              {showMessageDetail?.cover && <div className="col-sm-12">
                <LightGallery plugins={[lgThumbnail, lgZoom]} licenseKey={process.env.REACT_APP_LIGHT_GALLERY_LICENCE} selector={'.lg-item'}>
                  <div className="card border-0 overflow-hidden rounded-3 mb-5" style={{maxHeight: '420px'}}>
                    <a data-src={showMessageDetail?.cover} className="lg-item d-inline-block">
                      <img alt={''} src={showMessageDetail?.cover} className="img-fit" style={{animation: "fadeIn 0.5s"}}/>
                    </a>
                  </div>
                </LightGallery>
              </div>}
              <div className="col-sm-12">
                <h5 className="mb-3">{showMessageDetail?.title}</h5>
                <div dangerouslySetInnerHTML={{__html: showMessageDetail?.content}}></div>
              </div>

              {showMessageDetail?.type === 'CLASS_REVIEW_REQUEST' && <>

                <div className="col-sm-12 col-lg-8">
                  <div className="py-3">
                    <ClassReview eventId={showMessageDetail.eventID} onSuccess={(res) => {
                      if (eventTipModal?.current && showMessageDetail?.eventDetail?.price?.tipsEnabled) {
                          eventTipModal.current.openModal({eventId: showMessageDetail.eventID, event: showMessageDetail.eventDetail});
                      }
                      setMessages([...HelperService.removeItemFromList(messages, showMessageDetail.id, 'id')]);
                      closeModal();
                    }}/>
                  </div>
                </div>

                {/*{process.env.REACT_APP_DEBUG==='true' && showMessageDetail?.eventDetail?.price?.tipsEnabled &&*/}
                {/*    <div className="col-sm-12">*/}
                {/*      <div className="py-3">*/}
                {/*        <h6>Tip trainer - only for faster debug - this will not be shown on production enviroment</h6>*/}
                {/*        <p>If you were satisfied and wish to tip your trainer, you can do it here.</p>*/}
                {/*        <button type="button" className="btn btn-outline-primary" onClick={()=>{eventTipModal.current.openModal({eventId: showMessageDetail.eventID, event: showMessageDetail.eventDetail});setShowMessageDetail(null)}}>I want to tip</button>*/}
                {/*      </div>*/}
                {/*    </div>}*/}

              </>}

            </>}
          </div>
        </Section>
      </Modal.Body>
    </Modal>
  };

  const ClearInboxModal = function() {
    const closeModal = () => setShowClearInboxModal(null);

    return <Modal size='md' show={showClearInboxModal} onHide={closeModal} centered>
      <Modal.Header closeButton>
          <h4 className="header-stripe-blue col-sm-8 pb-1">Clear messages</h4>
      </Modal.Header>
      <Modal.Body className="p-sm-3 p-md-5">
        <Section animation={HelperService.getRandomAnimation()}>
          <div className="row">

            <div className="col-sm-12">
              <h5 className="mb-3">Do you want to clear all messages?</h5>
              <p>All messages will be permanently deleted.</p>
            </div>

            <div className="col-sm-12 text-center my-2">
             <button type="button" className="btn btn-outline-secondary me-2">Cancel</button>
             <button type="button" className="btn btn-danger" onClick={()=>cleanInbox()}>Clear</button>
            </div>

          </div>
        </Section>
      </Modal.Body>
    </Modal>
  };

  return (
      <>

        {!loaded && <InitialLoading/>}

        {loaded && messages?.length===0 && <Section animation={HelperService.getRandomAnimation()} className="position-relative section-padding-first">
          <div className={"container"}>
            <div className={"row"}>
              <div className={"col-sm-12 col-md-7 col-lg-6"}>
                <h1 className="header-stripe-blue">Inbox</h1>
                <p>We didn't find any messages yet. Come back later!</p>
              </div>
            </div>
          </div>
        </Section>}

        {loaded && messages?.length > 0 && <>
          <Section animation={HelperService.getRandomAnimation()} className="position-relative section-padding-first">
            <div className={"container"}>
              <div className={"row"}>
                <div className={"col-sm-12 col-md-7 col-lg-6"}>
                  <h1 className="header-stripe-blue">Inbox</h1>
                  <p>Messages from trainers and notifications about your activities</p>
                </div>
              </div>
            </div>
          </Section>

          <Section animation={HelperService.getRandomAnimation()} className="position-relative section-padding">
            <div className={"container"}>
              <div className={"row"}>
                <div className={"col-sm-12"}>

                  <div className="bg-light p-3 rounded-3">
                    {messages?.map(e =>
                        <div key={e.id} className={''}>
                          <InboxMessageCell message={e}/>
                        </div>
                    )}
                    {showLoadMore && <div className="text-center"><button disabled={submitting} className="btn btn-outline-primary my-2" onClick={()=>loadMoreMessages()}>Load more messages</button></div>}
                  </div>

                </div>
              </div>
              <div className={"row"}>
                <div className={"col-sm-12 text-center"}>
                  <button className="btn btn-outline-secondary border-0 my-3" disabled={submitting} onClick={()=>setShowClearInboxModal(true)}>Clear all messages</button>
                </div>
              </div>
            </div>
          </Section>

          <ClearInboxModal />
          <MessageDetailModal />
          <StripeEventTipModal ref={eventTipModal} />
        </>}
    </>
  );
}

Inbox.getLayout = function getLayout(page) {
  return (
      <MainLayout>
        {page}
      </MainLayout>
  )
}